
/**
 * 메시지 상태 정보
 */
export type MessagingGetChatRoomById200LastMessageStatus = {
  isRead?: boolean;
};
